module.exports = __webpack_public_path__ + "static/img/1.d4c0ed8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/1.png
// module id = 67ao
// module chunks = 0